import { useEffect } from 'react';
import { useLoading } from '../contexts/LoadingContext';
import { setLoadingProvider } from '../services/api';

const LoadingConnector = () => {
  const { setLoading } = useLoading();

  useEffect(() => {
    // Connect the loading context to the API service
    setLoadingProvider(setLoading);
  }, [setLoading]);

  return null; // This component doesn't render anything
};

export default LoadingConnector;
